const bws = {
  pythonUrl: process.env.REACT_APP_BWS_PYTHON,
};

export default {
  bws,
};
